import {
  pipe,
  prop,
  map,
  max,
  apply,
  reduce,
  path,
  juxt,
  sum,
  ifElse,
  ap,
  chain,
  divide,
  any,
  assoc,
  groupBy,
  filter,
  head,
  propOr,
} from 'ramda'
import { sumProp, propIsFalsy, mapMakeObj } from '@v/util/briqRamdaExt.js'
import {
  pathToNumberOfPersonsPerSegment,
  pathToQuantitiesPerSegment,
  getTotalNumberOfPersons,
} from '@v/bookings/edit/util/segmentUtil.js'

// chain(f,g)(x) = f(g(x))(x)
const normalizeSegmentQuantities = chain(
  totalQuantity => pipe(propOr(1, 'QuantityInProductGroup'), divide(totalQuantity)),
  pipe(pathToQuantitiesPerSegment, map(prop('Quantity')), sum),
)

const getNormalizedQuantity = ifElse(
  prop('isSegmentless'),
  p => p.ProductQuantity / (p.QuantityInProductGroup || 1),
  normalizeSegmentQuantities,
)

const getMaxNormalizedQuantity = pipe(
  prop('BookingProducts'),
  map(getNormalizedQuantity),
  reduce(max, -Infinity),
)

export const anySegmentlessQuantityMismatch = pipe(
  juxt([getTotalNumberOfPersons, getMaxNormalizedQuantity]),
  ([total, max]) => max > total,
)

const getNumberOfPersonsBySegment = pipe(
  pathToNumberOfPersonsPerSegment,
  groupBy(prop('SegmentCode')),
  map(head),
)

const getNormalizedQuantities = bp =>
  pipe(
    pathToQuantitiesPerSegment,
    mapMakeObj({
      segmentCode: prop('SegmentCode'),
      // it appears that QuantityInProductGroup can be null, like booking F3A45AF0D0A545D3A5F764B992355AE6 for BU Davor on test
      normalizedQuantity: ({ Quantity }) => Quantity / (bp.QuantityInProductGroup || 1),
    }),
  )(bp)

export function anySegmentQuantityMismatch(booking) {
  const numberBySegment = getNumberOfPersonsBySegment(booking)
  return pipe(
    prop('BookingProducts'),
    filter(propIsFalsy('isSegmentless')),
    chain(getNormalizedQuantities),
    any(({ normalizedQuantity, segmentCode }) => {
      const numberOfPersonsInSegment = numberBySegment[segmentCode]?.NumberOfPersons
      if (typeof numberOfPersonsInSegment === 'number') {
        return normalizedQuantity > numberOfPersonsInSegment
      }
      return false
    }),
  )(booking)
}
